import React, { useEffect, useMemo, useState } from 'react';
import { Menu, MenuProps } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLeftMenuItems } from './LeftMenuItems.component';
import '../../MuseDashboard.css'; // Assuming you have Muse Dashboard CSS

export const LeftMenu = () => {
  const { items } = useLeftMenuItems();

  const pathMapper = useMemo(
    () =>
      new Map([
        ['home', 'home'],
        ['users', 'users'],
        ['applications', 'applications'],
        ['vendors', 'vendors'],
        ['publishers', 'publishers'],
      ]),
    []
  );

  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const [current, setCurrent] = useState('home');

  useEffect(() => {
    const pathSegments = pathname.split('/').slice(1, 3).join('/') ?? 'not-found';
    setCurrent(pathMapper.get(pathSegments) ?? 'not-found');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const onClick: MenuProps['onClick'] = (e) => {
    switch (e.key) {
      case 'home':
        navigate('/');
        break;
      case 'users':
        navigate('/users');
        break;
      case 'applications':
        navigate('/applications');
        break;
      case 'vendors':
        navigate('/vendors');
        break;
      case 'publishers':
        navigate('/publishers');
        break;
      default:
        navigate('/not-found');
    }
    setCurrent(e.key);
  };

  return (
    <Menu
      onClick={onClick}
      selectedKeys={[current]}
      mode='inline'
      items={items}
      className="montserrat-font muse-menu full-height"
    />
  );
};
